import { COMMON_FUNCTION_NAME } from "@nova/common-interfaces";
export class FUNCTION_NAME extends COMMON_FUNCTION_NAME {
  static CUSTOMERS_CUSTOMER_GETOVERVIEW = "customers-customer-getOverview";
  static CUSTOMERS_CUSTOMER_GETINVOICEABLE = "customers-customer-getInvoiceable";
  static CUSTOMERS_CUSTOMER_GETALLASLIST = "customers-customer-getAllAsList";
  static CUSTOMERS_CUSTOMER_GETALLWITHBALANCE = "customers-customer-getAllWithBalance";
  static CUSTOMERS_CUSTOMER_SUSPEND = "customers-customer-suspend";
  static CUSTOMERS_CUSTOMER_ACTIVATE = "customers-customer-activate";
  static CUSTOMERS_CUSTOMER_REFRESHBALANCE = "customers-customer-refreshBalance";
  static CUSTOMERS_CUSTOMER_CANCEL = "customers-customer-cancel";
  static CUSTOMERS_CUSTOMER_SENDEMAIL = "customers-customer-sendEmail";
  static CUSTOMERS_CUSTOMER_SENDINVOICE = "customers-customer-sendInvoice";
  static CUSTOMERS_CUSTOMER_UPDATENEXTDUE = "customers-customer-updateNextDue";
  static ADMIN_PARCEL_GET = "admin-parcel-get";
  static ADMIN_PARCEL_GETKEYS = "admin-parcel-getKeys";
  static ADMIN_PARCEL_GETALL = "admin-parcel-getAll";
  static ADMIN_PARCEL_INSERT = "admin-parcel-insert";
  static ADMIN_PARCEL_REMOVE = "admin-parcel-remove";
  static ADMIN_PARCEL_UPDATE = "admin-parcel-update";
  static ADMIN_PARCEL_MERGE = "admin-parcel-merge";
  static ASSETS_ASSET_GET = "assets-asset-get";
  static ASSETS_ASSET_GETBYCUSTOMER = "assets-asset-getByCustomer";
  static ASSETS_ASSET_GETKEYS = "admin-parcel-getKeys";
  static ASSETS_ASSET_GETALL = "assets-asset-getAll";
  static ASSETS_ASSET_INSERT = "assets-asset-insert";
  static ASSETS_ASSET_UPDATE = "assets-asset-update";
  static ASSETS_ASSET_REMOVE = "assets-asset-remove";
  static ASSETS_ASSET_MERGE = "assets-asset-merge";
  static ASSETS_ASSET_REFRESH = "assets-asset-refresh";
  static ASSETS_ASSET_ASSIGN = "assets-asset-assign";
  static PRODUCTS_SERVICEPLAN_GET = "products-servicePlan-get";
  static PRODUCTS_SERVICEPLAN_GETKEYS = "products-servicePlan-getKeys";
  static PRODUCTS_SERVICEPLAN_GETALL = "products-servicePlan-getAll";
  static PRODUCTS_SERVICEPLAN_INSERT = "products-servicePlan-insert";
  static PRODUCTS_SERVICEPLAN_REMOVE = "products-servicePlan-remove";
  static PRODUCTS_SERVICEPLAN_UPDATE = "products-servicePlan-update";
  static PRODUCTS_SERVICEPLAN_MERGE = "products-servicePlan-merge";
  static PRODUCTS_SUBSCRIPTION_GET = "products-subscription-get";
  static PRODUCTS_SUBSCRIPTION_GETKEYS = "products-subscription-getKeys";
  static PRODUCTS_SUBSCRIPTION_GETALL = "products-subscription-getAll";
  static PRODUCTS_SUBSCRIPTION_INSERT = "products-subscription-insert";
  static PRODUCTS_SUBSCRIPTION_REMOVE = "products-subscription-remove";
  static PRODUCTS_SUBSCRIPTION_UPDATE = "products-subscription-update";
  static PRODUCTS_SUBSCRIPTION_UPDATEBYFIELD = "products-subscription-updateByField";
  static PRODUCTS_SUBSCRIPTION_SUSPEND = "products-subscription-suspend";
  static PRODUCTS_SUBSCRIPTION_ACTIVATE = "products-subscription-activate";
  static PRODUCTS_SUBSCRIPTION_CANCEL = "products-subscription-cancel";
  static PRODUCTS_SUBSCRIPTION_MERGE = "products-subscription-merge";
  static PRODUCTS_SUBSCRIPTION_GETBYCUSTOMER = "products-subscription-getByCustomer";
  static FIBERMANAGEMENT_FIBER_GET = "fiberManagement-fiber-get";
  static FIBERMANAGEMENT_FIBER_GETKEYS = "fiberManagement-fiber-getKeys";
  static FIBERMANAGEMENT_FIBER_GETALL = "fiberManagement-fiber-getAll";
  static FIBERMANAGEMENT_FIBER_INSERT = "fiberManagement-fiber-insert";
  static FIBERMANAGEMENT_FIBER_REMOVE = "fiberManagement-fiber-remove";
  static FIBERMANAGEMENT_FIBER_UPDATE = "fiberManagement-fiber-update";
  static FIBERMANAGEMENT_FIBER_MERGE = "fiberManagement-fiber-merge";
  static FIBERMANAGEMENT_CONDUIT_GET = "fiberManagement-conduit-get";
  static FIBERMANAGEMENT_CONDUIT_GETKEYS = "fiberManagement-conduit-getKeys";
  static FIBERMANAGEMENT_CONDUIT_GETALL = "fiberManagement-conduit-getAll";
  static FIBERMANAGEMENT_CONDUIT_INSERT = "fiberManagement-conduit-insert";
  static FIBERMANAGEMENT_CONDUIT_REMOVE = "fiberManagement-conduit-remove";
  static FIBERMANAGEMENT_CONDUIT_UPDATE = "fiberManagement-conduit-update";
  static FIBERMANAGEMENT_CONDUIT_MERGE = "fiberManagement-conduit-merge";
  static FIBERMANAGEMENT_HANDHOLE_GET = "fiberManagement-handhole-get";
  static FIBERMANAGEMENT_HANDHOLE_GETKEYS = "fiberManagement-handhole-getKeys";
  static FIBERMANAGEMENT_HANDHOLE_GETALL = "fiberManagement-handhole-getAll";
  static FIBERMANAGEMENT_HANDHOLE_INSERT = "fiberManagement-handhole-insert";
  static FIBERMANAGEMENT_HANDHOLE_REMOVE = "fiberManagement-handhole-remove";
  static FIBERMANAGEMENT_HANDHOLE_UPDATE = "fiberManagement-handhole-update";
  static FIBERMANAGEMENT_HANDHOLE_MERGE = "fiberManagement-handhole-merge";
  static NETWORK_DEVICE_GET_STATUSES = "network-device-getStatuses";
  static NETWORK_DEVICE_GET_STATUS = "network-device-getStatus";
  static THIRDPARTY_MERCURY_ACCOUNT_GET = "thirdParty-mercuryBankAccount-get";
  static THIRDPARTY_MERCURY_ACCOUNT_GETKEYS = "thirdParty-mercuryBankAccount-getKeys";
  static THIRDPARTY_MERCURY_ACCOUNT_GETALL = "thirdParty-mercuryBankAccount-getAll";
  static THIRDPARTY_MERCURY_TRANSACTION_GET = "thirdParty-mercuryBankTransaction-get";
  static THIRDPARTY_MERCURY_TRANSACTION_GETKEYS = "thirdParty-mercuryBankTransaction-getKeys";
  static THIRDPARTY_MERCURY_TRANSACTION_GETALL = "thirdParty-mercuryBankTransaction-getAll";
  static THIRDPARTY_MERCURY_TRANSACTION_INSERT = "thirdParty-mercuryBankTransaction-insert";
  static THIRDPARTY_MERCURY_TRANSACTION_UPDATE = "thirdParty-mercuryBankTransaction-update";
  static THIRDPARTY_MERCURY_TRANSACTION_MERGE = "thirdParty-mercuryBankTransaction-merge";
  static FINANCIAL_INVOICE_GET = "financial-invoice-get";
  static FINANCIAL_INVOICE_GETBYCUSTOMER = "financial-invoice-getByCustomer";
  static FINANCIAL_INVOICE_GETBYDATERANGE = "financial-invoice-getByDateRange";
  static FINANCIAL_INVOICE_MARKPAID = "financial-invoice-markPaid";
  static FINANCIAL_INVOICE_GETKEYS = "financial-invoice-getKeys";
  static FINANCIAL_INVOICE_GETALL = "financial-invoice-getAll";
  static FINANCIAL_INVOICE_INSERT = "financial-invoice-insert";
  static FINANCIAL_INVOICE_REMOVE = "financial-invoice-remove";
  static FINANCIAL_INVOICE_REINSTATE = "financial-invoice-reinstate";
  static FINANCIAL_INVOICE_UPDATE = "financial-invoice-update";
  static FINANCIAL_INVOICE_MERGE = "financial-invoice-merge";
  static FINANCIAL_PAYMENT_GET = "financial-payment-get";
  static FINANCIAL_PAYMENT_GETBYCUSTOMER = "financial-payment-getByCustomer";
  static FINANCIAL_PAYMENT_GETKEYS = "financial-payment-getKeys";
  static FINANCIAL_PAYMENT_GETALL = "financial-payment-getAll";
  static FINANCIAL_PAYMENT_INSERT = "financial-payment-insert";
  static FINANCIAL_PAYMENT_REMOVE = "financial-payment-remove";
  static FINANCIAL_PAYMENT_UPDATE = "financial-payment-update";
  static FINANCIAL_PAYMENT_MERGE = "financial-payment-merge";
  static FINANCIAL_PAYMENT_ADDPAYMENTINTENT = "financial-payment-addPaymentIntent";
  static THIRDPARTY_UISP_GET_OLT = "thirdParty-uisp-getDevicesOlt";
  static THIRDPARTY_UISP_GET_ONU = "thirdParty-uisp-getDevicesOnu";
  static THIRDPARTY_STRIPE_CREATE_PAYMENT_INTENT = "thirdParty-stripe-createPaymentIntent";
  static THIRDPARTY_STRIPE_GET_PAYMENT_METHODS = "thirdParty-stripe-getPaymentMethods";
  static THIRDPARTY_STRIPE_REMOVE_PAYMENT_METHOD = "thirdParty-stripe-removePaymentMethod";
  static PLATFORM_USER_RESETLINK = "platform-user-passwordResetLink";
}